<template>
	<section class="page-register-success">

		<PageHeader title="Registration" />

		<h2 class="text-center">Registration successful!</h2>
		<p class="text-center">You need to verify your e-mail <span class="text-primary">{{this.email}}</span>.</p>
		
		<router-link class="max-width btn btn-secondary" :to="{path: '/console/login'}">Back to Login</router-link>

	</section>
</template>

<script>
import PageHeader from "../shared/PageHeader";

export default {
	name: "RegisterSuccess",
	components: {
		PageHeader
	},
	data() {
		return {
			email: ''
		}
	},
	mounted() {
		this.email = this.$route.query.email;
	}
};
</script>

<style scoped>

.page-register-success {
	padding: 3em;
	max-width: 30em;
	margin: 0 auto;
}

</style>